module.exports = __webpack_public_path__ + "static/media/logo-scimed.460f6817.png";